import styled from "styled-components";

const CategoriesSliderStyle = styled.div`
  width: calc(100%);
  margin-top: 8px;

  .scroll-menu-arrow--disabled {
    opacity: 0.3;
    cursor: not-allowed !important;
  }

  .scroll-menu-arrow {
    cursor: pointer;
  }

  .menu-item-wrapper:focus {
    outline: none;
  }

  .menu-wrapper--inner {
  }

  .menu-item-wrapper.active {
    border: none;
  }
  .menu-item.active {
    border: none;
  }

  .arrow-prev {
    position: relative;
    margin-right: 4px;
    :after {
      background-image: linear-gradient(to left, #fff0, #fff 50%);
      content: "";
      position: absolute;
      top: -6px;
      left: 0;
      height: 35px;
      width: 20px;
      z-index: 10;
      margin-left: 24px;
    }
  }

  .arrow-next {
    position: relative;
    margin-left: 4px;
    :before {
      background-image: linear-gradient(to right, #fff0, #fff 50%);
      content: "";
      position: absolute;
      top: -6px;
      left: 0;
      height: 35px;
      width: 20px;
      z-index: 10;
      margin-left: -20px;
    }
  }
`;

const CategoryItem = styled.div`
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: auto !important;
  padding: 8px;
  outline: none;
  height: 32px;
  border-radius: 8px;
  background-color: #fff;
  transition: background-color 300ms ease-in-out;
  cursor: pointer;

  :hover {
    background-color: #e6e8f0;
  }
`;

const CategoryIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: #f4f5f8;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    border-radius: unset;
    width: 16px;
    height: 16px;
  }
  margin-right: 8px;
`;

const CategoryLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.14;
  color: #222939;
`;

const Arrow = styled.div`
  display: flex !important;
  height: 24px;
  width: 24px;
  background-color: #e6e8f0;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  transition: background-color 300ms ease-in-out;

  :hover {
    background-color: #dce0ea;
  }
`;

export {
  CategoryItem,
  CategoryIcon,
  CategoryLabel,
  CategoriesSliderStyle,
  Arrow
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/CategoriesSliderStyle.js